const setTelNumber = (state, payload) => {
    state.tel_number = payload;
};
const setCode = (state, payload) => {
    state.code = payload;
};
const setAuthenticated = (state, payload) => {
    state.isAuthenticated = payload;
};
export default {
    setTelNumber,
    setCode,
    setAuthenticated
};